import { consola } from "consola/browser";

const logger = consola.create({
  level: import.meta.env.DEV ? 4 : 2,
  formatOptions: {
    colors: true,
    date: true,
  },
});

export default logger;
